import React, { Component } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, kmFormatter } from "../utils";

class TopicWiseEmotionsBreakdownChart extends Component {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }
    getBarOptions = () => {
        let chartConfig = {};
        let chartData;
        let data = JSON.parse(JSON.stringify(this.props.data));
        let total = data.total;
        let self = this;

        if (this.props.expandWidget) {
            chartData = JSON.parse(JSON.stringify(data.maximizeBar));
        } else {
            chartData = JSON.parse(JSON.stringify(data.BarData));
        }

        chartData.map((d, i) => {
            if (i > 5) {
                d.visible = false;
            } else {
                d.visible = true;
            }
        });

        chartConfig = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                backgroundColor: "transparent",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                scrollablePlotArea: {
                    minHeight: this.props.expandWidget ? chartData.length * 50 : chartData.length,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                type: "category",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        let value = this.value.length > 20 ? this.value.substring(0, 20) + "..." : this.value;
                        return value;
                    },
                },
            },
            yAxis: {
                reversedStacks: false,
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: 0,
                max: 100,
                title: {
                    text: ``,
                },
                labels: {
                    format: "{text}%",
                },
            },
            plotOptions: {
                series: {
                    //         pointPadding: 0.1,
                    // groupPadding: 0.2,
                    //         pointWidth: 20,
                    borderWidth: 0,
                    stacking: "percent",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        // inside: false,
                        formatter: function () {
                            return kmFormatter(this.y);
                        },
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                    events: {
                        // legendItemClick: function () {
                        //     if (this.visible) {
                        //         this.setData([], false);
                        //     } else {
                        //         this.setData(chartData[this.index].data, false);
                        //     }
                        // },
                    },
                },
            },
            legend: {
                // enabled: this.props.showLegend,
                // width: "20%",
                // layout: "vertical",
                // align: "right",
                // padding: 3,
                // itemMarginTop: 3,
                // itemMarginBottom: 3,
                // verticalAlign: "middle",
                // // x: 50,
                // alignColumns: true,
                // itemStyle: {
                //     fontWeight: 500,
                //     textTransform: "normal",
                //     fontFamily: "'Roboto', sans-serif",
                // },
                enabled: this.props.showLegend,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: chartData,
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    let topicTotal = this.point.options.topic_total;
                    return `${this.key} | ${this.series.name} | <b>${((this.y * 100) / topicTotal).toFixed(1) + "%"}</b> | <b>${numberWithCommas(
                        this.y,
                    )}/${numberWithCommas(topicTotal)}</b>`;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            xAxis: {
                                labels: {
                                    formatter: function () {
                                        let value = this.value.length > 12 ? this.value.substring(0, 12) + "..." : this.value;
                                        return value;
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <>
                {this.props.currentChartType === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
            </>
        );
    }
}
export default TopicWiseEmotionsBreakdownChart;
